import { useTheme } from '@sds-system/system';
import { SpinnerRoot } from './\bSpinner.styled';
import type { SpinnerProps } from './Spinner.types';
import { SpinnerBar } from './SpinnerBar';
import { SpinnerDot } from './SpinnerDot';
import { SpinnerPulse } from './SpinnerPulse';
import { SpinnerRound } from './SpinnerRound';
import { SpinnerRoundCharge } from './SpinnerRoundCharge';
import { ThreeDot } from './ThreeDot';
import { ThreeDotBounce } from './ThreeDotBounce';

export const Spinner = ({
  variant = 'dot',
  size = 'M',
  styleComponents: styleComponent,
  ...props
}: SpinnerProps) => {
  const theme = useTheme();
  const spinnerProps: SpinnerProps = {
    ...props,
    width: theme.size[size],
    height: theme.size[size],
    variant,
  };

  return (
    <SpinnerRoot
      {...styleComponent?.root}
      height={spinnerProps.height}
      minHeight={spinnerProps.height}
      minWidth={spinnerProps.width}
      width={spinnerProps.width}
    >
      {variant === 'dot' && <SpinnerDot {...spinnerProps} />}
      {variant === 'threeDot' && <ThreeDot {...spinnerProps} />}
      {variant === 'threeDotBounce' && <ThreeDotBounce {...spinnerProps} />}
      {variant === 'round' && <SpinnerRound {...spinnerProps} />}
      {variant === 'bar' && <SpinnerBar {...spinnerProps} />}
      {variant === 'roundCharge' && <SpinnerRoundCharge {...spinnerProps} />}
      {variant === 'pulse' && <SpinnerPulse {...spinnerProps} />}
    </SpinnerRoot>
  );
};
